module.exports = __webpack_public_path__ + "img/arrow-bottom.8f2b49c2.svg";